// extracted by mini-css-extract-plugin
export var closeButton = "_lv-1";
export var closeX = "_lv-3";
export var container = "_lv-0";
export var image = "_lv-2";